import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { Layout, Button, Drawer, Space, Flex } from 'antd'

import { ArrowLeftOutlined } from '@ant-design/icons'

import { Link } from 'react-router-dom'

const PageHeader = ({title, extra, subTitle, backIcon, onBack}) => {
  const history = useHistory()
  return(
    <div>
      { ( title || backIcon  ) && <Space>

        { backIcon && <Button onClick={() => history.goBack() } >
          <ArrowLeftOutlined/>
        </Button> }
        <div style={{fontWeight:'bold'}}>{title}</div>
      </Space>}

      {/* Task007: wrap + gap, porque en celular no cabían buscador, filtro y 4 botones y "Logs" y "Descubrir" quedaban fuera */}
      { ( subTitle || extra) && <Flex justify='space-between' wrap='wrap' gap='small'>
      {subTitle}
      {extra}  
      </Flex>}

      
      
    </div>)
}

const Main = ({ children, pageHeader, subTitle }) => {

//  const menuButton = <Button  onClick={()=> setShowMenu(true)}>Menu</Button>

  const [showMenu, setShowMenu] = useState(false);
  const [extra, setExtra] = useState( []  );

  useEffect(()=>{
    let newExtra = []
    if ( pageHeader ) {
      if ( pageHeader.extraButtons ) {
        pageHeader.extraButtons.forEach( (item,index)=>{
          newExtra.push(<Button key={'button_' + index} onClick={ ()=> item.action() }>{item.name}</Button>)
        })
      }
//      newExtra.push(<Button key="menu" onClick={()=> setShowMenu(true)}>Menu</Button>)

      setExtra(newExtra)
    }
  },[pageHeader])


  return (
    <Layout
      style={{maxWidth:'800px', marginLeft:'auto', marginRight:'auto',  backgroundColor:'white', marginBottom:'20px'}}
    >
      { pageHeader && <PageHeader
        title={pageHeader.title}
        extra={extra}
        subTitle={subTitle}
        backIcon={ pageHeader.back ? true : false }
      />}

      <Layout.Content  >
        {children}
      </Layout.Content>

      <Drawer title="Menú" placement="right"  visible={showMenu} onClose={()=>setShowMenu(false)} >
         <Link to="/login"><p>Login</p></Link>
      </Drawer>

    </Layout>
  )
}

export default Main
